/**
 * Created by vladislav on 1/23/19
 */

const SharkCellView = BaseCellView.extend({
    ctor: function (sharkCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        this.animation = new cleverapps.Spine(bundles.shark.jsons.shark_json);
        this.animation.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.animation);
        this.initialize(sharkCell);
    },

    initialize: function (sharkCell) {
        this._super(sharkCell);

        sharkCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
        sharkCell.onCreateNew = this.createListener(this.createNew.bind(this));
        sharkCell.onTakeMove = this.createListener(this.takeMove.bind(this));
        sharkCell.onDisappear = this.createListener(this.disappear.bind(this));

        this.animation.setAnimation(0, `idle_${sharkCell.lives}`, true);
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};
        this.cell.onCreateNew = function () {};
        this.cell.onTakeMove = function () {};
        this.cell.onDisappear = function () {};

        this._super();
    },

    changeLives: function () {
        this.animation.setAnimation(0, `transition_${this.cell.lives}`, false);
        this.animation.setCompleteListener(() => {
            if (this.cell.lives > 0) {
                this.animation.setAnimation(0, `idle_${this.cell.lives}`, true);
            }
        });

        cleverapps.effects.fire(cleverapps.styles.SharkCellView.stageDecreaseEffect);
    },

    createNew: function () {
        this.setScale(0);
        this.runAction(
            new cc.Sequence(
                new cc.ScaleTo(0.1, 0.25).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.1, 0.15).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.3, 1.05).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.1, 1).easing(cc.easeBackOut())
            )
        );
        cleverapps.effects.fire(cleverapps.styles.SharkCellView.growUpEffect);
    },

    takeMove: function (callback) {
        const callback2 = function () {
            this.animation.setAnimation(0, "explode", false);

            if (Game.currentGame) {
                Game.currentGame.shakeField({
                    delay: 200,
                    target: cleverapps.Scenes.GetSceneComponent(Match3SceneComponent).movesView
                });
            }

            this.animation.setCompleteListener(() => {
                this.delete();
                callback();
                this.animation.setCompleteListener();
            });
        }.bind(this);

        this.setLocalZOrder(100);
        this.animation.setAnimation(0, "fly", true);

        this.runAction(new cc.Sequence(
            StandartAnimations.animateCollect(this, "moves", {
                scale: 1,
                collectEffect: true,
                effect: "match3.shark.poof"
            }),
            new cc.CallFunc(callback2)
        ));
    },

    disappear: function () {
        const animation = this.cell.lives > 1 ? `explode_idle_${this.cell.lives}` : "explode";
        this.setLocalZOrder(11);
        this.animation.setAnimation(0, animation, false);
        cleverapps.effects.fire(cleverapps.styles.SharkCellView.dieEffect);
        if (Game.currentGame) {
            Game.currentGame.shakeField({ delay: 200 });
        }

        this.animation.setCompleteListener(() => {
            this.setLocalZOrder(this.baseZOrder);
            this.animation.setCompleteListener();
        });
    }
});

cleverapps.styles.SharkCellView = {
    stageDecreaseEffect: "match3.shark.stage_decrease",
    growUpEffect: "match3.element.grow",
    dieEffect: "match3.shark.die"
};